import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ContactsImportColumnsSelectOptionsApi } from 'modules/contacts/contacts-import/types/contacts-import-column-select';
import { useMemo } from 'react';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useContactsImportColumnsSelectOptions() {
  const $ = _c(8);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return `${CONTACT_API}/contacts/import/columns`;
      } else {
        return null;
      }
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate: mutateContactsImportColumnsSelectOptions
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== data) {
    t2 = data ? [{
      id: null,
      caption: "\u2014"
    }, ...Object.entries(data).map(_temp)] : undefined;
    $[3] = data;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const contactsImportColumnsSelectOptions = t2;
  let t3;
  if ($[5] !== contactsImportColumnsSelectOptions || $[6] !== mutateContactsImportColumnsSelectOptions) {
    t3 = {
      contactsImportColumnsSelectOptions,
      mutateContactsImportColumnsSelectOptions
    };
    $[5] = contactsImportColumnsSelectOptions;
    $[6] = mutateContactsImportColumnsSelectOptions;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(t0) {
  const [id, caption] = t0;
  return {
    id,
    caption
  };
}